var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gt-flag-option",style:({ paddingLeft: _vm.depth * 1.25 + 'rem' })},[_c('span',{staticClass:"gt-flag-option__dot",class:{ 'gt-flag-option__dot--none': !_vm.dotColor },style:(_vm.dotColor ? { backgroundColor: _vm.dotColor } : undefined)}),_c('span',{staticClass:"gt-flag-option__text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }